<div class="splash-screen">
    <p>Setting everything up...you are getting redirected...</p>
    <div class="spinner-container">
      <div class="spinner"></div>
    </div>
  </div>